@if (conceptField.type === 'name') {
  <div
    class="concept-name"
    [ngStyle]="conceptsContainer.conceptType.is_hierarchic ? {'padding-left': concept.level * 20 + 'px'} : {}"
  >
    @if (!concept.is_parent) {
      <ng-container>
        @if (conceptsContainer.conceptType.is_hierarchic && concept.level === 1) {
          <button
            mat-icon-button
            [disabled]="conceptsContainer.loadingConcepts || !concept.parent_id"
            (click)="openConcept(parentId, true)"
          >
            <mat-icon>
              keyboard_arrow_left
            </mat-icon>
          </button>
        }

        @if (conceptsContainer.conceptType.is_hierarchic) {
          <div [ngClass]="{'children': concept.level > 1}"></div>
        }

        <span class="concept-name-text">
          {{value}}
        </span>

        @if (conceptsContainer.conceptType.is_hierarchic) {
          <button
            mat-icon-button [disabled]="conceptsContainer.loadingConcepts || concept.is_leaf"
            (click)="openConcept(concept.artifact_id, false)"
          >
            <mat-icon>
              keyboard_arrow_right
            </mat-icon>
          </button>
        }
      </ng-container>
    }
    @else {
      <ng-container>
        <button (click)="openParent()" mat-icon-button>
          <mat-icon>
            keyboard_arrow_left
          </mat-icon>
        </button>

        <span class="concept-name-text">
          {{value}}
        </span>
      </ng-container>
    }
  </div>
}
@else if (conceptField.type === 'select') {
  <ng-container>
    <mat-checkbox
      (click)="select($event)"
      (keydown)="null"
      [(ngModel)]="concept.$$selected">
    </mat-checkbox>
  </ng-container>
}
@else if (conceptField.type === 'check') {
  <ng-container>
    <mat-checkbox
      [checked]="value" [disabled]="true"></mat-checkbox>
  </ng-container>
}
@else if (conceptField.type === 'datetime') {
  <ng-container>
    <span>
      {{value}}
    </span>
  </ng-container>
}
@else if (conceptField.type === 'action') {
  <ng-container>
    <button
      class="action-icon-in-table text-blue-hover"
      mat-icon-button
      (click)="editTerm()"
    >
      <mat-icon>
        edit
      </mat-icon>
    </button>

    <app-admin-list-item-action
      [concept]="concept"
      [conceptsContainer]="conceptsContainer"
      (addChild)="addChildConcept()"
    ></app-admin-list-item-action>

    @if (conceptsContainer.showLinkToObject) {
      <a
        [routerLink]="useNewObjectPage ? [conceptsContainer.linkToObject, concept.artifact_id] : [conceptsContainer.linkToObject]"
        [queryParams]="{artifactId: concept.artifact_id, listName: 'overview'}"
        [target]="conceptsContainer.openLinkAsTab ? '_blank' : '_self'"
        class="action-icon-in-table" mat-icon-button
      >
        <mat-icon color="accent">
          arrow_forward
        </mat-icon>
      </a>
    }
  </ng-container>
}
